import bankAccountStatusMap from './bankAccountStatusMap';
import identityStatusMap from './identityStatusMap';

type IdentificationStatusType = 'identityStatus' | 'bankAccountStatus';

// Dispatches to the correct status map based on type; isCZResident only affects the identity map
export default function getIdentificationStatusProps(
  type: IdentificationStatusType,
  status: string,
  isCZResident?: boolean,
) {
  const identityMap = identityStatusMap(isCZResident ?? false);
  return type === 'identityStatus'
    ? identityMap[status]
    : bankAccountStatusMap[status];
}
